import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Layout from '../../components/layout/Layout';
import Constants from '../../config/constants';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import DataTable from '../../components/datatable/DataTable';
import CoolingTowerCreateModal from '../../modal/ac_central/CoolingTowerCreateModal';
import CoolingTowerEditModal from '../../modal/ac_central/CoolingTowerEditModal';
import CoolingTowerDuplicateModal from '../../modal/duplicate/CoolingTowerDuplicateModal';
import Alert from '../../modal/alert/Alert';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';
import {
  listCoolingTower,
  deleteCoolingTower,
  clearErrorCoolingTower,
} from '../../redux/ac_central/cooling_tower_actions';

export class CoolingTowerPage extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...textColumn,
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row => row.value
          ? <span><i className="fas fa-users"/> {t('public')}</span>
          : <span><i className="fas fa-user"/> {t('private')}</span>,
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'power_required',
        ...coeColumn,
        width: 200,
      }
    ];

    this.state = {
      selectedItem: null,
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  renderActionMenu() {
    return [
      <li>
        <a
          href="#"
          id="air-conditioning-cooling-tower-create"
          data-toggle="modal"
          data-target="#create-water-pump"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{this.props.t('create cooling tower')}</span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listCoolingTower(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category.value],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      categoryOption,
      selectedItem: item,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filtered,
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      t,
      errorMessage,
    } = this.props;

    const breadcrumbItems = [
      { name: t('air conditioning system'), path: '/ac' },
      { name: t('cooling tower'), path: '/ac/central/cooling_tower' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_ac_central_cooling_tower.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <CoolingTowerCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <CoolingTowerEditModal
          ct={item}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <CoolingTowerDuplicateModal
          item={item}
          show={isShowDuplicateModal}
          title={t('copy cooling tower')}
          label={t('new cooling tower name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete cooling tower')}
          body={`${t('do you want to delete')} ${item ? item.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteCoolingTower(item)}
        />
        <h1>{t('cooling tower')}</h1>
        <div style={{ backgroundColor: 'white' }}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              id="air-conditioning-cooling-tower-search-name"
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <DataTable
            columns={this.columns}
            data={this.props.coolingTower}
            onActionEdit={item => this.setState({ isShowEditModal: true, selectedItem: item.original, isEdited: false })}
            onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedItem: item.original, isDuplicated: false })}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  coolingTower: state.ac.coolingTower.orderedIds.map(id => state.ac.coolingTower.objects[id]),
  filteredCount: state.ac.coolingTower.filteredCount,
  isLoading: state.ac.coolingTower.isLoading,
  isCreating: state.ac.coolingTower.isCreating,
  isEditing: state.ac.coolingTower.isEditing,
  isDeleting: state.ac.coolingTower.isDeleting,
  isDuplicating: state.ac.coolingTower.isDuplicating,
  errorMessage: state.ac.coolingTower.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listCoolingTower: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listCoolingTower(pageSize, page, sorted, filtered, isPublic)),
    ),
  deleteCoolingTower: ({ id }) => defaultRejectHandler(dispatch(deleteCoolingTower(id))),
  clearError: () => dispatch(clearErrorCoolingTower()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CoolingTowerPage),
);



// WEBPACK FOOTER //
// ./src/pages/ac_central_unit/CoolingTowerPage.js